import { useState } from "react";
import { formatINR } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";
import EduSection from "@/components/EduSection";

export default function LoanEligibility() {
  const [income, setIncome] = useState("80000");
  const [emis, setEmis] = useState("5000");
  const [rate, setRate] = useState("8.5");
  const [years, setYears] = useState("20");
  const [foir, setFoir] = useState("50");

  const monthlyEMIable = (Number(income) * (Number(foir)/100)) - Number(emis);
  const r = (Number(rate)/12)/100, n = Number(years)*12;
  const maxLoan = monthlyEMIable > 0 && r > 0 ? (monthlyEMIable * (Math.pow(1+r, n) - 1)) / (r * Math.pow(1+r, n)) : 0;

  const rows = [
    ["Monthly Income", formatINR(Number(income))],
    ["Existing EMIs", formatINR(Number(emis))],
    ["FOIR (obligation ratio)", `${foir}%`],
    ["Max monthly EMI possible", formatINR(Math.max(0, monthlyEMIable))],
    ["Rate & Tenure", `${rate}% × ${years}y`],
    ["Eligible Loan Amount", formatINR(maxLoan)],
  ];

  return (
    <div>
      <CalcPageHeader title="Home Loan Eligibility" description="Estimate the maximum home loan you may qualify for based on income and existing obligations." slug="loan-eligibility" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 space-y-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label="Monthly Income (₹)"><input data-testid="le-income" type="number" value={income} onChange={(e)=>setIncome(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Existing EMIs (₹)"><input data-testid="le-emis" type="number" value={emis} onChange={(e)=>setEmis(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Interest Rate (%)"><input data-testid="le-rate" type="number" step="0.05" value={rate} onChange={(e)=>setRate(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Tenure (years)"><input data-testid="le-years" type="number" value={years} onChange={(e)=>setYears(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="FOIR %" hint="Banks typically use 40-55%"><input data-testid="le-foir" type="number" value={foir} onChange={(e)=>setFoir(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Loan Eligibility" slug="loan-eligibility" highlight={{ label: "Eligible Loan", value: formatINR(maxLoan) }} rows={rows} note="Banks also consider credit score, employment type & LTV. Use this as an indicative check." />
        </div>
      </div>
      <EduSection howItWorks={<p>FOIR (Fixed Obligations to Income Ratio) limits your total EMIs to a % of net income. Eligible loan = present value of the remaining EMI capacity.</p>} related={["loan-emi","stamp-duty","construction"]} />
    </div>
  );
}
